import { Button } from "semantic-ui-react";
import { cls } from "../../../views/NUI/utils";
import { BUTTON_STYLES, BUTTON_VARIANTS } from "./constants";
import { colorToBackgroundClass } from "../../functions";

export const ButtonContent = ({
	variant,
	image,
	ctaStyling,
	icon,
	priceTag,
	textColor,
	textStyling = "",
	buttonText,
	title,
	parsedClasses = "",
	buttonStyling,
	onClick = null,
	buttonColor,
	disabled=false
}) => {

	if (variant === BUTTON_VARIANTS.IMAGE && image && image.imageUrl) {
		return (
			<img src={image.imageUrl} alt={image.alt} className="w-auto h-10 mx-auto" />
		);
	}

	if (variant === BUTTON_VARIANTS.AS_LINK && !onClick) {
		return (
			<>
				{icon && (
					<img src={icon?.imageUrl} alt={icon?.alt} className={`w-[20px] h-[20px] object-contain mr-2`} />
				)}
				<span className="text-center text-is2-blue decoration-underline">{buttonText ?? title}</span>
			</>
		);
	}

	const linkStyling = (variant === BUTTON_VARIANTS.AS_LINK && onClick) ? "!p-0 !text-inherit !underline decoration-inherit cursor-pointer !bg-transparent":"";
	return (
		<Button
			className={cls([linkStyling, ctaStyling, parsedClasses, colorToBackgroundClass(buttonColor)])}
			primary={variant === BUTTON_VARIANTS.PRIMARY || buttonStyling?.includes(BUTTON_STYLES.ORANGE)}
			secondary={variant === BUTTON_VARIANTS.SECONDARY && !buttonStyling?.includes(BUTTON_STYLES.ORANGE)}
			basic={variant === BUTTON_VARIANTS.BASIC && !buttonStyling?.includes(BUTTON_STYLES.ORANGE)}
			onClick={onClick}
			disabled={disabled}
		>
			<div className={`flex ${buttonStyling?.includes(BUTTON_STYLES.REVERSE) ? "flex-row-reverse" : "flex-row"} gap-2 ${(priceTag || icon) ? "justify-between" : "justify-center"} items-center md:whitespace-nowrap`}>
				{icon && (
					<img src={icon?.imageUrl} alt={icon?.alt} className={`${buttonStyling?.includes(BUTTON_STYLES.TEXT_LARGE) ? "w-6 h-6" : "w-5 h-5"} object-contain`} />
				)}
				{variant === 'jumbo' ? (
					<span className={`${textColor} ${textStyling} text-md p-4 px-6 md:px-[128px] font-medium`}>{buttonText ?? title}</span>
				) : (
				<span className={`${textColor} ${textStyling}`}>{buttonText ?? title}</span>
				)}
				{priceTag && <span>{priceTag}</span>}
			</div>
		</Button>
	);
};
